import { client } from '../../graphql/client';
import {CreateMessage} from "../../graphql/generated-queries/create-message-queries";

export async function createMessage(input) {
  try {
    const { data } = await client.mutate({ mutation: CreateMessage, variables: { input: {...input.data} } });
    return { data: {...data.createMessage} };
  } catch (err) {
    console.error(JSON.stringify(err));
    throw new Error(err.graphQLErrors?.[0]?.message || err)
  }
}
